import { createFileRoute } from '@tanstack/react-router';
import DatabasePlayerPage from '../../../../pages/database/DatabasePlayerPage';

export const Route = createFileRoute('/_authenticated/$owner/database/$id/')({
  component: DatabasePlayerPage
});
